import { Link } from "react-router-dom";
import { relationshipIntakePath } from "@/lib/relationshipIntake";

export default function NewCallModeSelector({
  activeMode,
  relationshipId = "",
  customerName = "",
  from = "new-call",
}) {
  const recordingPath = relationshipIntakePath("/upload", relationshipId, customerName);
  const transcriptPath = relationshipIntakePath("/upload", relationshipId, customerName, { mode: "transcript" });
  const sharedState = { customerName, relationshipId, from };

  return (
    <nav className="new-call-mode-selector" aria-label="New call input methods">
      <Link
        to={recordingPath}
        state={sharedState}
        className={`new-call-mode-selector__option${activeMode === "recording" ? " is-active" : ""}`}
        aria-current={activeMode === "recording" ? "page" : undefined}
      >
        Recording
      </Link>
      <Link
        to={transcriptPath}
        state={sharedState}
        className={`new-call-mode-selector__option${activeMode === "transcript" ? " is-active" : ""}`}
        aria-current={activeMode === "transcript" ? "page" : undefined}
      >
        Transcript
      </Link>
    </nav>
  );
}
